
Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};
Monet.UI.Fields.NumberRange = (function () {

    function NumberRange() {

        Monet.UI.Fields.Range.apply(this, arguments);

        this.inputIni = new Monet.UI.Fields.Number();
        this.inputFin = new Monet.UI.Fields.Number();

        this.setValue = function (values) {
            this.inputIni.setValue(values.ini);
            this.inputFin.setValue(values.fin);
        };

        this.getValue = function () {
            return {
                ini: this.inputIni.getValue() || 0,
                fin: this.inputFin.getValue() || 0
            };
        };

        this.createElement = function () {

            this.labelRange = document.createElement("label");
            this.rootEl.appendChild(this.inputIni.render());
            this.rootEl.appendChild(this.inputFin.render());
        };

    }

    return NumberRange;

}());
